import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function ReorderRouteIcon({
  color = RoutalPalette.primary40,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14" style={{ width: `15px`, height: `15px`, ...props.style }}>
      <path fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M10.7,1.1v11.8" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.42,10.17l-2.73,2.73-2.73-2.73"
      />
      <path fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M3.3,12.9V1.1" />
      <path fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M.58,3.83L3.3,1.1l2.73,2.73" />
    </SvgIcon>
  );
}
